import { FormControl, FormHelperText } from '@mui/material';
import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import { type Dictionaries_Types_Enum_Enum } from '@graphql/__generated__/graphql';
import { DictionarySelect } from '@modules/_shared/components/dictionary-select/DictionarySelect';
import { RaLabel } from '@modules/_shared/components/form/RaLabel';
import { useLocale } from '@shared/hooks/locale';

export type RaDictionaryProps = {
  control: Control<any>;
  name: string;
  label: string;
  dictionaryType: Dictionaries_Types_Enum_Enum;
  disabled?: boolean;
  required?: boolean;
  multiple?: boolean;
  valueField?: 'id' | 'name';
};

export const RaDictionary = ({
  name,
  label,
  control,
  dictionaryType,
  disabled = false,
  multiple = false,
  required,
  valueField = 'name',
}: RaDictionaryProps) => {
  const { t } = useLocale();
  const rules = {
    required: required ? t('This field is required') : undefined,
  };

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <FormControl fullWidth error={!!error}>
          <RaLabel label={label} required={required} />
          <DictionarySelect
            disabled={disabled}
            defaultValue={value}
            dictionaryType={dictionaryType}
            onChange={onChange}
            size="small"
            multiple={multiple}
            clearOnBlur={value == null}
            valueField={valueField}
          />
          {error?.message && <FormHelperText>{error.message}</FormHelperText>}
        </FormControl>
      )}
    />
  );
};
